import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div
      className="privacy-policy-page"
      style={{ backgroundColor: "black", minHeight: "100vh", color: "white" }}
    >
      <div className="text-center py-5" style={{ backgroundColor: "black" }}>
        <div className="container">
          <h1 className="mb-4">Privacy Policy</h1>
          <p className="lead mb-4" style={{ color: "white" }}>
            How we handle and protect your data
          </p>
        </div>
      </div>

      <Container>
        <Row className="my-5">
          <Col xs={12} md={10} lg={10} xl={12} className="mx-auto">
            <h2 className="mb-4">Information We Collect</h2>
            <p>
              We collect information that you provide directly to us, including:
              <br /><br />
              • Account information (email address, username, password)
              <br />
              • Profile information
              <br />            </p>
          </Col>
        </Row>

        <hr className="my-5" style={{ borderColor: 'white' }} />

        <Row className="my-5">
          <Col xs={12} md={10} lg={10} xl={12} className="mx-auto">
            <h2 className="mb-4">How We Use Your Information</h2>
            <p>
              We use the information we collect to:
              <br /><br />
              • Provide, maintain, and improve our services
              <br />
              • Process your transactions
              <br />
              • Send you technical notices and support messages
              <br />
              • Communicate with you about products, services, and events
              <br />
              • Protect against fraudulent or illegal activity
            </p>
          </Col>
        </Row>

        <hr className="my-5" style={{ borderColor: 'white' }} />

        <Row className="my-5">
          <Col xs={12} md={10} lg={10} xl={12} className="mx-auto">
            <h2 className="mb-4">Data Security</h2>
            <p>
              We take reasonable measures to help protect your personal information 
              from loss, theft, misuse, and unauthorized access. Your data is encrypted 
              during transmission and at rest.
            </p>
          </Col>
        </Row>

        <hr className="my-5" style={{ borderColor: 'white' }} />

        <Row className="my-5">
          <Col xs={12} md={10} lg={8} xl={12} className="mx-auto">
            <h2 className="mb-4">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              Email: brian@theformbettor.com
            </p>
            <Link to="/" className="btn btn-primary mt-3">
              Back to Home
            </Link>
          </Col>
        </Row>
      </Container>

      <footer className="text-center py-3 mt-5">
        <p>&copy; 2025 The Form Bettor LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;